<template>
    <div>
        <sau-vps-xs-console :service="service"></sau-vps-xs-console>
    </div>
</template>
<script>
import VpsXsConsole from './_Console';
export default {
    props: ['service'],
    components: {
        'sau-vps-xs-console': VpsXsConsole
    },
    data() {
        return {
        }
    },
    created() {
    },
    methods: {
    },
    computed: {
    }
}
</script>